import Home2 from "../../Home2";

const Home = () => {
    return <Home2/>
}

export default Home
